import { render, staticRenderFns } from "./myHeader2.vue?vue&type=template&id=33353dbe&scoped=true&"
import script from "./myHeader2.vue?vue&type=script&lang=js&"
export * from "./myHeader2.vue?vue&type=script&lang=js&"
import style0 from "./myHeader2.vue?vue&type=style&index=0&id=33353dbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33353dbe",
  null
  
)

export default component.exports